import React, {createContext, useContext, useEffect, useState} from 'react';
import {I18nextProvider} from 'react-i18next';
import PropTypes from 'prop-types';
import {i18n} from '@/settings';
import moment from 'moment';
import es from 'antd/es/locale/es_ES';
import en from 'antd/es/locale/en_US';
import {ConfigProvider} from 'antd';

const InternationalizationContext = createContext();

const ANT_LOCALE = {
  es,
  en,
};

export const getSimpleLocale = (lng) => lng.split('-')[0];


function InternationalizationProvider({children}) {
  const [locale, setLocale] = useState(getSimpleLocale(i18n.language));

  useEffect(() => {
    i18n.subscribe(lng=> {
      const momentLng = getSimpleLocale(lng);
      moment.locale(momentLng);
      setLocale(momentLng);
    });
  }, []);

  const validateMessages = i18n.t('validateMessages', { returnObjects: true });

  return (
    <InternationalizationContext.Provider value={{
      locale,
      setLocale,
    }}>

      <I18nextProvider i18n={i18n}>
        <ConfigProvider locale={ANT_LOCALE[locale]}  form={{ validateMessages }}>
          {children}
        </ConfigProvider>
      </I18nextProvider>
    </InternationalizationContext.Provider>
  );
}

function useInternationalization() {
  const context = useContext(InternationalizationContext);
  if (context === undefined) {
    throw new Error('useInternationalization must be used within a InternationalizationProvider');
  }
  const {
    locale,
    setLocale,
  } = context;

  return {locale, setLocale};
}

InternationalizationProvider.propTypes = {
  children: PropTypes.any
};


export {InternationalizationProvider, useInternationalization};
